let ModalFileParameters = {
    Object: null,
    Type: 'none',
    FileName: 'untitled',
    Pdf: false,
    IsNew: 1
}
export default ModalFileParameters;